import Sidebar from '@components/Details/Sidebar'
import MobileHeader from '@components/Details/MobileHeader'

const DetailLayout = ({
  itemId,
  children,
  auction,
  setInfoSlideOutOpen,
  itemClosed,
  pageNumber,
  showBackButton = true,
  isItemPage,
}: any) => {
  const {
    auctionNumber,
    title,
    location: { address, city, state, zip, isFranchise },
    utcEndDateTime,
    auctionPickupDates,
    endTimeText,
  } = auction

  return (
    <div className={'grid grid-cols-5 gap-5'}>
      <aside className={'sticky top-30 self-start hidden lg:block'}>
        <Sidebar
          title={title}
          auctionNumber={auctionNumber}
          auction={auction}
          showBackButton={showBackButton}
          address={address}
          city={city}
          state={state}
          zip={zip}
          pageNumber={pageNumber}
          utcEndDateTime={utcEndDateTime}
          itemClosed={itemClosed}
          auctionPickupDates={auctionPickupDates}
          setInfoSlideOutOpen={setInfoSlideOutOpen}
          itemId={itemId}
          endTimeText={endTimeText}
          isFranchise={isFranchise}
        />
      </aside>
      <div className={'col-span-5 lg:col-span-4'}>
        <MobileHeader
          title={title}
          auctionNumber={auctionNumber}
          auction={auction}
          showBackButton={showBackButton}
          address={address}
          city={city}
          state={state}
          zip={zip}
          pageNumber={pageNumber}
          utcEndDateTime={utcEndDateTime}
          itemClosed={itemClosed}
          auctionPickupDates={auctionPickupDates}
          setInfoSlideOutOpen={setInfoSlideOutOpen}
          isItemPage={isItemPage}
          itemId={itemId}
          endTimeText={endTimeText}
        />
        {children}
      </div>
    </div>
  )
}

export default DetailLayout
